import { render } from "./Equipment.vue?vue&type=template&id=80fb2c86&scoped=true"
import script from "./Equipment.vue?vue&type=script&lang=js"
export * from "./Equipment.vue?vue&type=script&lang=js"

import "./Equipment.vue?vue&type=style&index=0&id=80fb2c86&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80fb2c86"]])

export default __exports__